import { render, staticRenderFns } from "./FilterSummaryItemTapirMk.vue?vue&type=template&id=a8361db2&"
import script from "./FilterSummaryItemTapirMk.vue?vue&type=script&lang=js&"
export * from "./FilterSummaryItemTapirMk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports